import { createFileRoute, Outlet } from "@tanstack/react-router"

import { AppShell } from "@/components/layout/app-shell"
import { MainSidebar } from "@/components/layout/main-sidebar"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main"
)({
  component: MainLayout,
})

function MainLayout() {
  return (
    <AppShell sidebar={<MainSidebar />}>
      <Outlet />
    </AppShell>
  )
}
